<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 9,
            title: "CERTIFICACION DE PAGO ELECTRONICO CENTRALIZADO ADUANERO",
            columns: ["clave", "descripcion", "actions"],
            options: {
                filterable: ["clave", "descripcion"],
                sortable: ["clave", "descripcion"],

                headings: {
                    clave: "Clave",
                    descripcion: "Descripción",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion"
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion"
            },
            camposLayout: [{
                clave: "[Clave del Tipo de Certificación]",
                descripcion: "[Descripción del Tipo de Certificación]"
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: ""
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave",
                    value: "",
                    maxlen: 100
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 200
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>